import { useEffect, useState, useContext, useRef } from "react";
import { APIStatusContext } from "../../../providers/apiStatusProvider";

import Section from "../../ui/content/Section";
import Button from "../../ui/form/Button";

export default function Vetro() {
    const [fileContent, setFileContent] = useState(undefined);
    const [vetroType, setVetroType] = useState();

    const [filename, setFileName] = useState();
    const [responseMessage, setResponseMessage] = useState();
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    const { setIsLoading } = useContext(APIStatusContext);
    const { isLoading } = useState(false);

    function checkForEmptyValue(val) {
        return val !== null && val !== undefined && val !== '' ? val : null;
    }

    async function updateVetro() {
        setIsLoading(true);

        const vetroMaxLimit = 50000;
        let features =  [];

        // Format for Vetro
        // Set any empty values to null
        for (let i = 0, len = fileContent.length; i < len; i++) {
            switch (vetroType) {
                case "FAT":
                    var properties = {
                        "VFL Verified": checkForEmptyValue(fileContent[i]["VFL Verified"]),
                        "Placed": checkForEmptyValue(fileContent[i]["Placed"]),
                        "Launch Level": checkForEmptyValue(fileContent[i]["Launch Level"]),
                        "v_status": checkForEmptyValue(fileContent[i]["v_status"]),
                    }
                    break;
                case "Handhole":
                    var properties = {
                        "Placed": checkForEmptyValue(fileContent[i]["Placed"]),
                        "Labeled": checkForEmptyValue(fileContent[i]["Labeled"]),
                        "Fiber Placed": checkForEmptyValue(fileContent[i]["Fiber Placed"]),
                        "Tracer Connected": checkForEmptyValue(fileContent[i]["Tracer Connected"]),
                        "Fiber Labeled": checkForEmptyValue(fileContent[i]["Fiber Labeled"]),
                    }
                    break;
                case "Pedestal":
                    var properties = {
                        "Placed": checkForEmptyValue(fileContent[i]["Placed"]),
                        "Conduit to secondary verified": checkForEmptyValue(fileContent[i]["Conduit to secondary verified"]),
                        "Jetlined": checkForEmptyValue(fileContent[i]["Jetlined"]),
                        "Conduits Capped": checkForEmptyValue(fileContent[i]["Conduits Capped"])
                    }
                    break;
                case "Splice":
                    var properties = {
                        "Launch Lvl": checkForEmptyValue(fileContent[i]["Launch Lvl"]),
                        "Spliced": checkForEmptyValue(fileContent[i]["Spliced"]),
                        "In Service": checkForEmptyValue(fileContent[i]["In Service"])
                    }
                    break;
                default:
                    break;
            }

            if (fileContent[i]['vetro_id']) {
                let feature = {
                    "type": "Feature",
                    "x-vetro": { "vetro_id": fileContent[i]['vetro_id'].substring(0, 36)},
                    "properties": properties
                }

                // if all dates are filled, set to operational
                const rowIsOperational = Object.values(properties).every(x => x !== null);
                if (rowIsOperational) {
                    feature["x-vetro"]["status_id"] = 4; // in-built Vetro status id for "operational"
                }

                features.push(feature);
            }
        }

        const req = await fetch(`${process.env.REACT_APP_VETRO_API_URL}/v2/features`, {
            method: "PATCH",
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'token': process.env.REACT_APP_VETRO_API_TOKEN,
            },
            body: JSON.stringify({
                "limit": vetroMaxLimit,
                "features": features
            })
        });
        let res = await req.json();

        setFileContent(undefined);
        setIsLoading(false);

        if (res.success) {
            setResponseMessage(`${vetroType} file ${filename} successfully pushed to Vetro!`);
            setShowSuccessMessage(true);
        } else {
            setResponseMessage(`${vetroType} file ${filename} failed... Response from Vetro: ${res.message}`);
            setShowSuccessMessage(true);
        }
    }

    const handleButtonClick = (event) => {
        // Trigger the hidden file input
        const fileInput = document.getElementById('myFileInput');
        fileInput.click();
        setVetroType(event.target.id)
    };

    const handleFileChange = (event) => {
        setShowSuccessMessage(false);
        setShowErrorMessage(false);
        const file = event.target.files[0];

        if (file && file.name.endsWith(".csv")) {
            const reader = new FileReader();
            setFileName(file.name);

            reader.onload = (e) => {
                const csv = e.target.result;

                const lines = csv.split("\n");
                const headers = lines[0].split(",");
                const result = [];

                // Excel likes to add a random return character at the end of the string for CSVs, very dumb I know
                const index = headers.indexOf('vetro_id\r');
                if (index !== -1) {
                    headers[index] = 'vetro_id';
                }

                for (let i = 1, len = lines.length; i < len; i++) {
                    const currentLine = lines[i].split(",");
                    const obj = {};

                    for (let j = 0; j < headers.length; j++) {
                        obj[headers[j]] = currentLine[j]; // set headers as key
                    }

                    result.push(obj);
                }

                setFileContent(result);
            }
            reader.readAsText(file);
        } else if (!file || (file && !file.name.endsWith(".csv"))) {
            setShowErrorMessage(true);
            setResponseMessage("File is required to be a .csv");
        }
    };

    // Set loading spinner icons
    useEffect(() => {
        if (isLoading) {
            setIsLoading(true);
        }

        return () => {
            setIsLoading(false);
        }
    }, [isLoading]);

    // Push to Vetro once file content is read
    useEffect(() => {
        if (fileContent) {
            updateVetro();
        }
    }, [fileContent]);


    useEffect(() => {
        if (filename) {
            setFileName(filename);
        }
    }, [filename]);


    return (
        <div>
            <div className="space-y-4">
                {/* Vetro upload buttons */ }
                <Section title="Network Points">
                    <div className="flex flex-col sm:flex-row flex-wrap gap-2 lg:gap-y-4 lg:gap-x-4 items-stretch">
                        <input
                            type = "file"
                            id = "myFileInput"
                            style = {{ display: 'none' }}
                            onChange = { handleFileChange }
                        />

                        <Button
                            onClick = { handleButtonClick }
                            text = "FAT"
                            id = "FAT"
                            className = "md:w-40"
                        />
                        <Button
                            onClick = { handleButtonClick }
                            text = "Handhole"
                            id="Handhole"
                            className = "md:w-40"
                        />
                        <Button
                            onClick = { handleButtonClick }
                            text = "Pedestal"
                            id = "Pedestal"
                            className = "md:w-40"
                        />
                        <Button
                            onClick = { handleButtonClick }
                            text = "Splice Closure"
                            id = "Splice"
                            className = "md:w-40"
                        />
                    </div>
                </Section>

                {showSuccessMessage &&
                    <div className="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative" role="alert">
                        <span className="block sm:inline">{responseMessage}</span>
                    </div>
                }

                {showErrorMessage &&
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                        <span className="block sm:inline">{responseMessage}</span>
                    </div>
                }
            </div>
        </div>
    );
}